<div id="terminal-{{windowId}}" class="main-app container-fluid full-size p-2">
</div>